module.exports = __webpack_public_path__ + "img/planning-and-list.683380e7.png";